export const ontologyFilters = {
  akuuttihoito: [
	  'akuuttihoito', 
	  'akuuttihoitopalvelut',
  ],
  etälääkärit: ['lääkärin etävastaanotto'],
  haavanhoito: ['haavanhoito'],
  kuulonhuolto: ['kuulonhuolto'],
  lääkehuolto: ['lääkehuolto'],
  verenpaineenmittaus: ['verenpaineenmittaus'],
  kotisairaanhoito: [
	  'kotisairaanhoito', 
	  'injektiot', 
	  'verensokeri',
  ],
  ateriapalvelut: [
	  'ateriapalvelut', 
	  'kotiateriapalvelut',
  ],
  hieronta: ['hieronta'],
  jalkojenhoito: [
	  'jalkojenhoito', 
	  'jalkojenhoitajat',
  ],
 // 'kampaajat ja parturit': ['kampaajat ja parturit'],
 'kotihoito ja kotipalvelu': [
      'kotihoito',
	  'kotihoitotyö',
	  'kotipalvelut',
  ],
    kotikuntoutus: [
	  'kotikuntoutus',
      'kotikuntoutus (kuntoutus)',
      'kotikuntoutus (avokuntoutus)',
	  'avokuntoutus',
  ],
  kotisiivous: [
	  'kotisiivous', 
	  'kotisiivous (siivous)', 
	  'kotisiivous (siivouspalvelut)',
  ],
  kylvetyspalvelut: ['kylvetyspalvelut'],
  pyykinpesu: [
      'pyykinpesu (vaatehuoltopalvelut)',
	  'pyykinpesu (pesu, pesu (tekstiilihuolto))',
  ],
  talonmiehet: ['talonmiehet'],
  'ulkoalueiden hoito': ['ulkoalueiden hoito'],
  'muu vanhusten hoivatyö': ['vanhusten hoivatyö'],
  apteekit: [
	  'apteekit', 
	  'apteekkarit',
  ],
  asiointi: ['asiointi'],
  digineuvonta: ['digineuvonta'],
  'henkilökohtaiset avustajat': ['henkilökohtaiset avustajat'],
  hoitotarvikkeet: [
	  'hoitotarvikkeet',
	  'omahoitotarvikkeet',
  ],
  kaupassakäynti: ['kaupassakäynti'],
  keskusteluapu: ['keskusteluapu'],
  'kotona asumista tukevat apuvälineet ja teknologia': [
	  'terveysteknologia',
	  'apuvälineteknologia',
	  'apuvälineet',
	  'apuvälinepalvelut',
	  'hyvinvointiteknologia',
	  'geroteknologia',
  ],
  kuljetuspalvelut: ['kuljetuspalvelut'],
  neuvontapalvelut: [
	  'neuvontapalvelut',
	  'neuvonta',
	  'neuvontapalvelu',
	  'ohjaus (neuvonta ja opastus)',
	  'palveluohjaus',
  ],
  'pienet sairaanhoidolliset toimenpiteet': ['vanhustenneuvolat'],
  päihdepalvelut: [
      'päihdepalvelut',
	  'päihdeongelmat',
	  'päihdetyö',
  ],
  päivätoiminta: ['päivätoiminta'],
  sielunhoito: ['sielunhoito'],
  vapaaehtoistyö: [
	  'vapaaehtoistyö',
	  'vapaaehtoiset',
	  'ystävätoiminta',
	  'naapuritoiminta',
  ],
  vertaistuki: [
	  'vertaistuki',
	  'vertaisryhmät',
	  'vertaistukitoiminta',
  ],
  virkistystoiminta: [
      'virkistystoiminta',
	  'kulttuuritapahtumat',
	  'kulttuuriharrastukset',
  ],
  'huoli itsestä tai läheisestä': [
	  'sosiaalipäivystys',
	  'etsivä vanhustyö',
  ],
  mielenterveys: [
	  'mielenterveys',
	  'avoterveydenhuollon mielenterveystyö',
	  'mielenterveyshoitajat',
	  'mielenterveyskäynnit',
	  'mielenterveystyö (sosiaalityö)',
	  'mielenterveyspalvelut',
	  'vanhuspsykiatria',
  ],
  muistisairaus: [
    'muistisairaus',
    'muistisairaat',
    'muistisairaudet',
  ],
  omaishoito: [
    'omaishoidon tuki',
	'omaishoidon tuki (rahallinen tuki)',
    'omaishoitajat',
    'omaishoito',
    'vanhuspalvelun omaishoidon tuki',
	'etäomaishoito',
	'omaisjärjestöt',
  ],
  saattohoito: ['saattohoito'],
  senioriasuminen: ['senioriasuminen'],
};

// https://koodistot.suomi.fi/code;registryCode=ptv;schemeCode=ptvelti;codeCode=KE13
export const lifeEventsFilters = {
  omaishoito: [
    'KE13', //'Omaishoitajana toimiminen'
  ],
};

export const serviceClassFilters = {
  'muut palvelut': [
    'P4.2', //'Vanhusten palvelut'
  ],
  'kotihoito ja kotipalvelut': [
    'P4.3', // 'Kotihoito ja kotipalvelut'
  ],
  kotisairaanhoito: [
    'P5.14', // 'Kotisairaanhoito ja omaishoito'
  ],
};

export const targetGroupFilters = {
  'muut palvelut': [
    'KR1.1', //'Ikäihmiset'
  ],
};
